import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path
      stroke={color}
      strokeWidth="2"
      d="m16.243 2.354 5.656 5.657L7.757 22.153 2.1 16.496zM16.243 13.667l-2.829-2.828M19.071 10.839 16.243 8.01M10.586 19.324l-2.829-2.828M13.414 16.496l-2.828-2.829"
    />
  </svg>
);
